'use strict';

import $ from 'jquery';
import 'jquery-match-height';

export default class HomeEvents {
  constructor() {
    $('.home-events__item').matchHeight();
  }
}
